import { useId } from 'react';

interface KensukeSymbolProps {
  size?: number;
  className?: string;
  title?: string;
  variant?: 'gradient' | 'mono';
}

/** Brand mark — design-system blue (`#2563eb`), not legacy purple. */
export default function KensukeSymbol({
  size = 120,
  className,
  title,
  variant = 'gradient',
}: KensukeSymbolProps) {
  const rawId = useId().replace(/:/g, '');
  const titleId = title ? `kensuke-symbol-title-${rawId}` : undefined;
  const gradientId = `kensukeGradient-${rawId}`;
  const stroke = variant === 'gradient' ? `url(#${gradientId})` : 'currentColor';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      aria-labelledby={titleId}
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      {title ? <title id={titleId}>{title}</title> : null}
      {variant === 'gradient' ? (
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="100" y2="100">
            <stop offset="0%" stopColor="#2563eb" />
            <stop offset="100%" stopColor="#1d4ed8" />
          </linearGradient>
        </defs>
      ) : null}
      <circle cx="50" cy="50" r="44" fill="none" stroke={stroke} strokeWidth="6" />
      <path
        d="M35 18h30"
        fill="none"
        stroke={stroke}
        strokeWidth="5"
        strokeLinecap="round"
      />
      <path
        d="M40 18v28L26 70a12 12 0 0 0 10 18h28a12 12 0 0 0 10-18L60 46V18"
        fill="none"
        stroke={stroke}
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="44" cy="48" r="3.5" fill={stroke} />
      <circle cx="58" cy="56" r="4" fill={stroke} />
      <path
        d="M24 74c10 8 42 8 52 0"
        fill="none"
        stroke={stroke}
        strokeWidth="5"
        strokeLinecap="round"
      />
    </svg>
  );
}
